import React, { useState, useEffect } from 'react';
import { X, Sparkles } from 'lucide-react';

const OpeningAnnouncement: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Verificar si ya se mostró el anuncio en esta sesión
    const hasSeenAnnouncement = sessionStorage.getItem('hasSeenOpeningAnnouncement');
    
    if (!hasSeenAnnouncement) {
      // Pequeño delay para que la animación de entrada se vea suave después de cargar la página
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('hasSeenOpeningAnnouncement', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      {/* Backdrop con blur */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-500"
        onClick={handleClose}
      />

      {/* Modal Content */}
      <div className="relative bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-500 scale-100 animate-fade-in-up">
        {/* Decoración de fondo */}
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-primary-accent via-pink-300 to-primary-accent" />
        <div className="absolute -top-10 -right-10 w-32 h-32 bg-primary-light rounded-full opacity-50 blur-2xl" />
        <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-primary-accent/20 rounded-full opacity-50 blur-2xl" />

        {/* Botón Cerrar */}
        <button 
          onClick={handleClose}
          className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 transition-colors z-10"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="p-8 md:p-10 text-center relative z-0">
          {/* Icono o Logo */}
          <div className="mx-auto w-16 h-16 bg-primary-light rounded-full flex items-center justify-center mb-6 shadow-inner">
            <Sparkles className="w-8 h-8 text-primary-accent" />
          </div>

          {/* Títulos */}
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary-dark mb-2">
            ¡Gran Apertura!
          </h2>
          <div className="w-16 h-1 bg-primary-accent mx-auto mb-6 rounded-full" />
          
          <div className="text-gray-600 mb-8 leading-relaxed font-sans flex flex-col items-center">
            <p className="mb-4">Bienvenido a la nueva experiencia digital de</p>
            <img 
              src="/images/frahda-logo-final.png" 
              alt="Frahda Studio" 
              className="h-20 md:h-24 object-contain mb-6"
            />
            <p>
              Descubre nuestros productos exclusivos, agenda tus citas y explora nuestros cursos desde cualquier lugar.
            </p>
          </div>

          {/* Botón de Acción */}
          <button
            onClick={handleClose}
            className="group relative inline-flex items-center justify-center px-8 py-3 font-medium text-white transition-all duration-200 bg-primary-dark rounded-full hover:bg-gray-800 hover:shadow-lg hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark"
          >
            <span>Comenzar a Explorar</span>
            <Sparkles className="w-4 h-4 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default OpeningAnnouncement;
